export default __webpack_public_path__ + "static/media/Icons_Boat_Icon_Grey.4e26d151.svg";